import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';

// BugHerd #49: +/- 클릭 외에 직접 숫자 입력도 가능하게.
// 부모 value 가 바뀌면 input 도 sync. blur/Enter 시 min/max 로 클램프.
export default function Counter({ value, onChange, min = 1, max = 6, unit }) {
  const { t } = useTranslation();
  const resolvedUnit = unit ?? t('common.people');
  const [draft, setDraft] = useState(String(value));

  useEffect(() => { setDraft(String(value)); }, [value]);

  const commit = (raw) => {
    const cleaned = String(raw).replace(/[^0-9]/g, '');
    if (cleaned === '') { onChange(min); setDraft(String(min)); return; }
    const n = Math.max(min, Math.min(max, Number(cleaned)));
    onChange(n);
    setDraft(String(n));
  };

  return (
    <div className="flex items-center justify-between h-12 bg-mono-50 border border-mono-100 rounded-lg overflow-hidden">
      <button
        type="button"
        onClick={() => onChange(Math.max(min, value - 1))}
        className="w-12 h-12 flex items-center justify-center text-mono-400 hover:bg-orange-50 hover:text-orange-500 transition disabled:opacity-30"
        disabled={value <= min}
      >
        <Icon name="minus" size={18} />
      </button>
      <div className="flex-1 flex items-center justify-center gap-0.5">
        <input
          type="text"
          inputMode="numeric"
          value={draft}
          onChange={(e) => setDraft(e.target.value.replace(/[^0-9]/g, ''))}
          onBlur={(e) => commit(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.currentTarget.blur(); } }}
          className="w-16 text-center bg-transparent text-[15px] font-semibold sm:text-sm sm:font-medium text-mono-900 focus:outline-none"
        />
        {resolvedUnit && <span className="text-[15px] font-semibold sm:text-sm sm:font-medium text-mono-900">{resolvedUnit}</span>}
      </div>
      <button
        type="button"
        onClick={() => onChange(Math.min(max, value + 1))}
        className="w-12 h-12 flex items-center justify-center text-mono-400 hover:bg-orange-50 hover:text-orange-500 transition disabled:opacity-30"
        disabled={value >= max}
      >
        <Icon name="plus" size={18} />
      </button>
    </div>
  );
}
